import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { RSS } from '@bibliocommons/deprecated-base-icons';
import { openPopUpWindow } from '@bibliocommons/utils-browser';

import './RSSButton.scss';

const RSS_WINDOW_NAME = 'RSSWindow';

function handleOnClick(e, url) {
  e.preventDefault();
  openPopUpWindow({ url, RSS_WINDOW_NAME });
}

export default function RSSButton({ url }) {
  return (
    <a href={url} className="btn btn-link cp-rss-button" onClick={e => handleOnClick(e, url)}>
      <RSS />
      <ScreenReaderMessage>
        <FormattedMessage id="ada_rss_button" />
      </ScreenReaderMessage>
    </a>
  );
}

RSSButton.propTypes = {
  url: PropTypes.string.isRequired
};
